module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-position": "left",
      "label-width": "180px"
    }
  }, [_c('div', {
    staticClass: "section-body"
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否开启：",
      "prop": "ad_title"
    }
  }, [_c('el-switch', {
    attrs: {
      "width": 60,
      "active-value": "true",
      "inactive-value": "false",
      "inactive-color": "#ccc",
      "active-text": "开启",
      "inactive-text": "关闭",
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.form.is_open),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_open", $$v)
      },
      expression: "form.is_open"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册赠送积分：",
      "prop": "ad_title"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "controls-position": "right",
      "placeholder": "注册赠送积分",
      "min": 0,
      "max": 9999999
    },
    model: {
      value: (_vm.form.point),
      callback: function($$v) {
        _vm.$set(_vm.form, "point", $$v)
      },
      expression: "form.point"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册返上级积分：",
      "prop": "ad_title"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "controls-position": "right",
      "placeholder": "注册返上级积分",
      "min": 0,
      "max": 9999999
    },
    model: {
      value: (_vm.form.rebate),
      callback: function($$v) {
        _vm.$set(_vm.form, "rebate", $$v)
      },
      expression: "form.rebate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保 存")])], 1)], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fc45763a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc45763a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/point.vue
// module id = 2998
// module chunks = 0